import {
  GET_CONDITION_QUERY_TEMPLATE,
  CREATE_CONDITION_QUERY_TEMPLATE,
  UPDATE_CONDITION_QUERY_TEMPLATE,
  GETTING_CONDITION_QUERY_TEMPLATE,
  CREATING_CONDITION_QUERY_TEMPLATE,
  UPDATING_CONDITION_QUERY_TEMPLATE,
  GETTING_CONDITION_QUERY_TEMPLATE_SUCCEEDED,
  CREATING_CONDITION_QUERY_TEMPLATE_SUCCEEDED,
  UPDATING_CONDITION_QUERY_TEMPLATE_SUCCEEDED,
  GETTING_CONDITION_QUERY_TEMPLATE_FAILED,
  CREATING_CONDITION_QUERY_TEMPLATE_FAILED,
  UPDATING_CONDITION_QUERY_TEMPLATE_FAILED,
  SET_CURRENT_CONDITION_QUERY_TEMPLATE,
  UNSET_CURRENT_CONDITION_QUERY_TEMPLATE,
  CLEAR_CONDITION_QUERY_TEMPLATE_STORE,
  GET_PAGINATED_CONDITION_QUERY_TEMPLATES,
  GETTING_PAGINATED_CONDITION_QUERY_TEMPLATES,
  GETTING_PAGINATED_CONDITION_QUERY_TEMPLATES_SUCCEEDED,
  GETTING_PAGINATED_CONDITION_QUERY_TEMPLATES_FAILED,
  GET_MINIMAL_CONDITION_QUERY_TEMPLATES,
  GETTING_MINIMAL_CONDITION_QUERY_TEMPLATES,
  GETTING_MINIMAL_CONDITION_QUERY_TEMPLATES_SUCCEEDED,
  GETTING_MINIMAL_CONDITION_QUERY_TEMPLATES_FAILED,
  GET_CONDITION_QUERIES,
  GETTING_CONDITION_QUERIES_SUCCEEDED,
  GETTING_CONDITION_QUERIES_FAILED,
  DELETING_CONDITION_QUERY_SUCCEEDED,
  DELETE_CONDITION_QUERY,
  DELETING_CONDITION_QUERY_FAILED,
  RESET_SNACKBAR,
  UPDATE_CONDITION_QUERY_FILTERS,
  RESET_CONDITION_QUERY_FILTERS
} from './actions';
import { createReducer } from '@reduxjs/toolkit';
import sortBy from 'lodash.sortby';
import { produce } from 'immer';
import { ProductType } from 'constants.js';
import { mapExpressionFromResposne } from 'store/helpers';

const deCamelizer = str => {
  return str
    .replace(/([A-Z])/g, ' $1')
    .replace(/(\d+)/g, ' $1')
    .replace(/^./, str => str.toUpperCase());
};

const initialState = {
  getting: false,
  gettingPaginated: true,
  gettingMinimal: false,
  creating: false,
  creatingPaginated: false,
  updating: false,
  deleting: false,
  deletingPaginated: false,
  list: [],
  paginatedList: [],
  minimalList: [],
  minimalTotalRecords: 0,
  current: {
    name: '',
    conditionExpression: [],
    productType: ProductType.Product
  },
  error: {
    message: null,
    raw: null
  },
  isTemplateSaving: false,
  isTemplateSaved: false,
  filters: {
    pageNo: 0,
    searchInput: '',
    sortBy: 'name',
    sortOrder: 'ASC',
    rowsPerPage: 10,
    totalCount: 0,
    displayActive: true,
    filterTemplates: [],
    filterProductNames: [],
    filterProductCategories: []
  },
  conditionExpression: [],
  loadQueryInput: false,
  snackbarInfo: { show: false },
  isDeleting: false
};

export default createReducer(initialState, {
  [GET_CONDITION_QUERIES]: (state, action) => {
    return {
      ...state,
      gettingQueryData: true,
      loadQueryInput: false
    };
  },
  [GETTING_CONDITION_QUERIES_SUCCEEDED]: (state, action) => {
    return {
      ...state,
      gettingQueryData: false,
      conditionExpression: action.payload
    };
  },
  [GETTING_CONDITION_QUERIES_FAILED]: (state, action) => {
    return {
      ...state,
      gettingQueryData: false
    };
  },
  [DELETE_CONDITION_QUERY]: state => {
    return {
      ...state,
      snackbarInfo: { show: false },
      isDeleting: true,
      deleteSucceeded: false
    };
  },
  [DELETING_CONDITION_QUERY_SUCCEEDED]: state => {
    return {
      ...state,
      snackbarInfo: {
        show: true,
        message: 'Deleted Successfully.',
        severity: 'success'
      },
      isDeleting: false,
      deleteSucceeded: true
    };
  },
  [DELETING_CONDITION_QUERY_FAILED]: state => {
    return {
      ...state,
      isDeleting: false,
      snackbarInfo: {
        show: true,
        message: 'Unable to delete.',
        severity: 'error'
      }
    };
  },
  [RESET_SNACKBAR]: state => {
    return {
      ...state,
      snackbarInfo: { show: false }
    };
  },
  [GET_PAGINATED_CONDITION_QUERY_TEMPLATES]: state => {
    return state;
  },
  [GETTING_PAGINATED_CONDITION_QUERY_TEMPLATES]: state => {
    state.gettingPaginated = true;
    return state;
  },
  [GETTING_MINIMAL_CONDITION_QUERY_TEMPLATES]: state => {
    state.gettingMinimal = true;
    return state;
  },
  [GETTING_PAGINATED_CONDITION_QUERY_TEMPLATES_SUCCEEDED]: (state, action) => {
    state.gettingPaginated = false;
    state.paginatedList = action.payload.data.map(template => ({
      ...template
    }));
    return state;
  },
  [GETTING_MINIMAL_CONDITION_QUERY_TEMPLATES_SUCCEEDED]: (state, action) => {
    state.gettingMinimal = false;
    state.minimalList = action.payload.data || [];
    state.minimalTotalRecords = action.payload.totalRecords || 0;
    return state;
  },
  [GETTING_PAGINATED_CONDITION_QUERY_TEMPLATES_FAILED]: (state, action) => {
    state.gettingPaginated = false;
    state.creatingPaginated = false;
    state.deletingPaginated = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [GETTING_MINIMAL_CONDITION_QUERY_TEMPLATES_FAILED]: (state, action) => {
    state.gettingMinimal = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [GET_CONDITION_QUERY_TEMPLATE]: state => {
    return state;
  },
  [CREATE_CONDITION_QUERY_TEMPLATE]: state => {
    state.isTemplateSaved = false;
    state.isTemplateSaving = true;
    return state;
  },
  [UPDATE_CONDITION_QUERY_TEMPLATE]: state => {
    state.isTemplateSaved = false;
    state.isTemplateSaving = true;
    return state;
  },
  [GETTING_CONDITION_QUERY_TEMPLATE]: state => {
    state.getting = true;
    return state;
  },
  [CREATING_CONDITION_QUERY_TEMPLATE]: state => {
    state.creating = true;
    state.current = {
      ...state.current
    };
    return state;
  },
  [UPDATING_CONDITION_QUERY_TEMPLATE]: state => {
    state.updating = true;
    return state;
  },
  [GETTING_CONDITION_QUERY_TEMPLATE_SUCCEEDED]: (state, action) => {
    const { template, eventMetaData = [] } = action.payload;

    let hydratedEventMetaData = sortBy(
      eventMetaData.map(data => ({
        ...data,
        productName: data.schemaType === 'EVENT'
          ? `Event Product - ${template.productName}`
          : data.schemaType === 'ENRICHMENT' ? `Enrichment Product - ${data.enrichmentProduct}` : data.schemaTypeDisplayName,
        schemaConditionAttributes: data.schemaConditionAttributes
          .map(a => ({
            key: a.conditionAttribute,
            name:
              !a.displayName || a.displayName === ''
                ? deCamelizer(a.conditionAttribute)
                : a.displayName,
            dataType: a.conditionAttributeType || a.attributeFieldType,
            text: `{{${a.conditionAttribute}}}`,
            attributeFieldType: a.attributeFieldType,
            metaAttribute: a.metaAttribute,
            description: a.description,
            productName: data.schemaType === 'EVENT'
              ? `Event Product - ${template.productName}`
              : data.schemaType === 'ENRICHMENT' ? `Enrichment Product - ${data.enrichmentProduct}` : data.schemaTypeDisplayName,
            subAttribute: a.subAttribute,
          }))
      })).filter(data => template.productType === 'LIST' ? (data.schemaType === 'EVENT' || data.schemaType === 'ENRICHMENT' || data.schemaType === 'LIST') : data ),
      'name'
    );

    let eventFields = [];
    hydratedEventMetaData.map(data =>
      eventFields.push(...data.schemaConditionAttributes.filter(f => !f.metaAttribute).map(f => ({ ...f, schemaType: data.schemaType })).sort((a, b) => a?.name.localeCompare(b?.name)))
    );

    let updatedTemplate = produce(template, templateDraft => {
      templateDraft.eventMetaData = hydratedEventMetaData;
      templateDraft.conditionExpression = mapExpressionFromResposne(
        templateDraft?.conditionExpression || {},
        eventFields
      );
    });

    state.getting = false;
    state.creating = false;
    state.updating = false;
    state.current = { ...updatedTemplate };
    return state;
  },
  [CREATING_CONDITION_QUERY_TEMPLATE_SUCCEEDED]: (state, action) => {
    state.getting = false;
    state.creating = false;
    state.updating = false;
    state.isTemplateSaving = false;
    state.isTemplateSaved = true;
    state.current = { ...action.payload };
    return state;
  },
  [UPDATING_CONDITION_QUERY_TEMPLATE_SUCCEEDED]: (state, action) => {
    state.getting = false;
    state.creating = false;
    state.updating = false;
    state.isTemplateSaving = false;
    state.isTemplateSaved = true;
    state.current = { ...action.payload };
    return state;
  },
  [GETTING_CONDITION_QUERY_TEMPLATE_FAILED]: (state, action) => {
    state.getting = false;
    state.creating = false;
    state.deleting = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [CREATING_CONDITION_QUERY_TEMPLATE_FAILED]: (state, action) => {
    state.getting = false;
    state.creating = false;
    state.deleting = false;
    state.isTemplateSaving = false;
    state.isTemplateSaved = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [UPDATING_CONDITION_QUERY_TEMPLATE_FAILED]: (state, action) => {
    state.getting = false;
    state.creating = false;
    state.deleting = false;
    state.isTemplateSaving = false;
    state.isTemplateSaved = false;
    state.error = {
      message: action.payload.message,
      raw: action.payload
    };
    return state;
  },
  [SET_CURRENT_CONDITION_QUERY_TEMPLATE]: (state, action) => {
    state.current = {
      ...action.payload
    };
    state.isTemplateSaved = false;
    return state;
  },
  [UNSET_CURRENT_CONDITION_QUERY_TEMPLATE]: state => {
    state.current = { ...initialState.current };
    return state;
  },
  [CLEAR_CONDITION_QUERY_TEMPLATE_STORE]: state => {
    let updatedState = {
      ...initialState
    };
    return updatedState;
  },
  [UPDATE_CONDITION_QUERY_FILTERS]: (state, action) => {
    state.gettingPaginated = true;
    state.filters = {
      ...state.filters,
      ...action.payload
    };
    return state;
  },
  [RESET_CONDITION_QUERY_FILTERS]: state => {
    state.gettingPaginated = true;
    state.filters = {
      ...initialState.filters
    };
    return state;
  }
});
